import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { MONTH_ITEM_HEIGHT as m } from "../config.js";
import { getMonthString as S, getQuarterString as y, getYearString as g } from "../utils.js";
import { useDualCalendarProps as _, useDualCalendar as b } from "./use-dual-calendar.js";
import { warnOnce as C } from "../../../_utils/naive/warn.js";
import k from "../../../_mixins/use-locale.js";
import $ from "../../../_internal/focus-detector/src/FocusDetector.js";
import { XButton as p } from "../../../button/src/Button.js";
import { resolveSlotWithTypedProps as f, resolveWrappedSlot as O } from "../../../_utils/vue/resolve-slot.js";
import u from "../../../_internal/scrollbar/src/Scrollbar.js";
import v from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/virtual-list/src/VirtualList.js";
import { defineComponent as R, watchEffect as M, onMounted as z, h as a } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const V = R({
  name: "MonthRangePanel",
  props: Object.assign(Object.assign({}, _), {
    type: {
      type: String,
      required: !0
    }
  }),
  setup(o) {
    process.env.NODE_ENV !== "production" && M(() => {
      var e;
      !((e = o.actions) === null || e === void 0) && e.includes("now") && C("date-picker", `The \`now\` action is not supported for n-date-picker of ${o.type}type`);
    });
    const i = b(o, o.type), {
      dateLocaleRef: s
    } = k("DatePicker"), t = (e, d, l, c) => {
      const {
        handleColItemClick: h
      } = i, r = !1;
      return a("div", {
        "data-n-date": !0,
        key: d,
        class: [`${l}-date-panel-month-calendar__picker-col-item`, e.isCurrent && `${l}-date-panel-month-calendar__picker-col-item--current`, e.selected && `${l}-date-panel-month-calendar__picker-col-item--selected`, r],
        onClick: () => {
          h(e, c);
        }
      }, e.type === "month" ? S(e.dateObject.month, e.monthFormat, s.value.locale) : e.type === "quarter" ? y(e.dateObject.quarter, e.quarterFormat, s.value.locale) : g(e.dateObject.year, e.yearFormat, s.value.locale));
    };
    return z(() => {
      i.justifyColumnsScrollState();
    }), Object.assign(Object.assign({}, i), {
      renderItem: t
    });
  },
  render() {
    var o, i, s;
    const {
      mergedClsPrefix: t,
      mergedTheme: e,
      shortcuts: d,
      type: l,
      renderItem: c,
      onRender: h
    } = this;
    return h == null || h(), a("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${t}-date-panel`, `${t}-date-panel--daterange`, !this.panel && `${t}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, a("div", {
      ref: "startDatesElRef",
      class: `${t}-date-panel-calendar ${t}-date-panel-calendar--start`
    }, a("div", {
      class: `${t}-date-panel-month-calendar`
    }, a(u, {
      ref: "startYearScrollbarRef",
      class: `${t}-date-panel-month-calendar__picker-col`,
      theme: e.peers.Scrollbar,
      themeOverrides: e.peerOverrides.Scrollbar,
      container: () => this.virtualListContainer("start"),
      content: () => this.virtualListContent("start"),
      horizontalRailStyle: {
        zIndex: 1
      },
      verticalRailStyle: {
        zIndex: 1
      }
    }, {
      default: () => a(v, {
        ref: "startYearVlRef",
        items: this.startYearArray,
        itemSize: m,
        showScrollbar: !1,
        keyField: "ts",
        onScroll: this.handleStartYearVlScroll,
        paddingBottom: 4
      }, {
        default: ({
          item: r,
          index: n
        }) => c(r, n, t, "start")
      })
    }), l === "monthrange" || l === "quarterrange" ? a("div", {
      class: `${t}-date-panel-month-calendar__picker-col`
    }, a(u, {
      ref: "startMonthScrollbarRef",
      theme: e.peers.Scrollbar,
      themeOverrides: e.peerOverrides.Scrollbar
    }, {
      default: () => [(l === "monthrange" ? this.startMonthArray : this.startQuarterArray).map((r, n) => c(r, n, t, "start")), l === "monthrange" && a("div", {
        class: `${t}-date-panel-month-calendar__padding`
      })]
    })) : null)), a("div", {
      class: `${t}-date-panel__vertical-divider`
    }), a("div", {
      ref: "endDatesElRef",
      class: `${t}-date-panel-calendar ${t}-date-panel-calendar--end`
    }, a("div", {
      class: `${t}-date-panel-month-calendar`
    }, a(u, {
      ref: "endYearScrollbarRef",
      class: `${t}-date-panel-month-calendar__picker-col`,
      theme: e.peers.Scrollbar,
      themeOverrides: e.peerOverrides.Scrollbar,
      container: () => this.virtualListContainer("end"),
      content: () => this.virtualListContent("end"),
      horizontalRailStyle: {
        zIndex: 1
      },
      verticalRailStyle: {
        zIndex: 1
      }
    }, {
      default: () => a(v, {
        ref: "endYearVlRef",
        items: this.endYearArray,
        itemSize: m,
        showScrollbar: !1,
        keyField: "ts",
        onScroll: this.handleEndYearVlScroll,
        paddingBottom: 4
      }, {
        default: ({
          item: r,
          index: n
        }) => c(r, n, t, "end")
      })
    }), l === "monthrange" || l === "quarterrange" ? a("div", {
      class: `${t}-date-panel-month-calendar__picker-col`
    }, a(u, {
      ref: "endMonthScrollbarRef",
      theme: e.peers.Scrollbar,
      themeOverrides: e.peerOverrides.Scrollbar
    }, {
      default: () => [(l === "monthrange" ? this.endMonthArray : this.endQuarterArray).map((r, n) => c(r, n, t, "end")), l === "monthrange" && a("div", {
        class: `${t}-date-panel-month-calendar__padding`
      })]
    })) : null)), O(this.datePickerSlots.footer, (r) => r ? a("div", {
      class: `${t}-date-panel-footer`
    }, r) : null), !((o = this.actions) === null || o === void 0) && o.length || d ? a("div", {
      class: `${t}-date-panel-actions`
    }, a("div", {
      class: `${t}-date-panel-actions__prefix`
    }, d && Object.keys(d).map((r) => {
      const n = d[r];
      return Array.isArray(n) || typeof n == "function" ? a(p, {
        size: "tiny",
        onMouseenter: () => {
          this.handleRangeShortcutMouseenter(n);
        },
        onClick: () => {
          this.handleRangeShortcutClick(n);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => r
      }) : null;
    })), a("div", {
      class: `${t}-date-panel-actions__suffix`
    }, !((i = this.actions) === null || i === void 0) && i.includes("clear") ? f(this.datePickerSlots.clear, {
      onClear: this.handleClearClick,
      text: this.locale.clear
    }, () => [a(p, {
      theme: e.peers.Button,
      themeOverrides: e.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    })]) : null, !((s = this.actions) === null || s === void 0) && s.includes("confirm") ? f(this.datePickerSlots.confirm, {
      disabled: this.isRangeInvalid,
      onConfirm: this.handleConfirmClick,
      text: this.locale.confirm
    }, () => [a(p, {
      theme: e.peers.Button,
      themeOverrides: e.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isRangeInvalid,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    })]) : null)) : null, a($, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  V as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/monthrange.js
// module id = 1672
// module chunks = 67